module.exports = __webpack_public_path__ + "static/media/fire.093679c7.png";